import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CommonMenuService {
  // Function to generate menu items based on the provided configuration
  commonShowData(config: { label: string; icon: string; visible?: boolean; command?: () => void }[]): any[] {
    return [
      {
        items: config.map((item) => ({
          label: item.label,
          icon: item.icon,
          visible: item.visible,
          command: item.command,
        }))
      }
    ];
  }
}
